/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 * A previous program enrollment for a returning family, along with the suggested next program type.
 * @export
 * @interface PotentialInvitePreviousProgram
 */
export interface PotentialInvitePreviousProgram {
  /**
   * The program type the family was previously enrolled in.
   * @type string
   * @memberof PotentialInvitePreviousProgram
   */
  previousProgramType: string
  /**
   * The suggested next program type based on the previous enrollment. Null if there is no natural progression.
   * @type string
   * @memberof PotentialInvitePreviousProgram
   */
  suggestedNextProgramType?: string | null
}

export function PotentialInvitePreviousProgramFromJSON(
  json: any
): PotentialInvitePreviousProgram {
  return PotentialInvitePreviousProgramFromJSONTyped(json, false)
}

export function PotentialInvitePreviousProgramFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PotentialInvitePreviousProgram {
  if (json === undefined || json === null) {
    return json
  }
  return {
    previousProgramType: json['previousProgramType'],
    suggestedNextProgramType: !exists(json, 'suggestedNextProgramType')
      ? undefined
      : json['suggestedNextProgramType'],
  }
}

export function PotentialInvitePreviousProgramToJSON(
  value?: PotentialInvitePreviousProgram | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    previousProgramType: value.previousProgramType,
    suggestedNextProgramType: value.suggestedNextProgramType,
  }
}
